import React, { Component } from "react";
import PropTypes from "prop-types";
import { shallowEqual } from "recompose";
import Dropzone from "react-dropzone";
import { UploadClient } from "../../restClient";
import { red500 } from "material-ui/styles/colors";
import CircularProgress from "material-ui/CircularProgress";
import Snackbar from "material-ui/Snackbar";
import isNil from "lodash.isnil";
import SortableImagePreview from "./SortableImagePreview";
import { Flex } from "rebass";

const ERROR_MESSAGE_MAX_SIZE = "Please resize your image less then 1MB";
const ERROR_MESSAGE_FAILED = "Upload image failed";

class ImageMultiCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      openSnackBar: false,
      dataImage: !isNil(props.dataImage) ? props.dataImage : [],
      message: "Please try again"
    };
  }

  handleRequestClose = () => {
    this.setState({
      openSnackBar: false
    });
  };

  convertTagsName = name => {
    let brand = name.trim();
    brand = brand.replace(/\s+/g, "-");
    brand = brand.replace(/[&/\\#,+[/\]()$~%.@'":*!`^?<>{}]/g, "");
    return brand;
  };

  onDrop = (accepted, rejected) => {
    if (accepted.length > 0 && rejected.length === 0) {
      this.setState({
        isLoading: true
      });

      const { nameCampaign } = this.props;
      let paramsCaption = this.convertTagsName(nameCampaign);
      const url = "/products/upload";
      let formData = new FormData();
      // caption as brand-product name
      formData.append("caption", paramsCaption);
      accepted.forEach(file => {
        formData.append("photos", file, file.name);
      });
      UploadClient(formData, url)
        .then(response => response.json())
        .then(data => {
          this.onAdd(data.url);
        })
        .catch(e => {
          this.setState({
            isLoading: false,
            openSnackBar: true,
            message: ERROR_MESSAGE_FAILED
          });
        });
    } else {
      this.setState({
        isLoading: false,
        openSnackBar: true,
        message: ERROR_MESSAGE_MAX_SIZE
      });
    }
  };

  onAdd = url => {
    const updatedFiles = [...this.state.dataImage, url];
    this.setState({ dataImage: updatedFiles, isLoading: false });
    this.props.onUpdatePhotos(updatedFiles);
  };

  onRemove = file => () => {
    const filteredFiles = this.state.dataImage.filter(
      stateFile => !shallowEqual(stateFile, file)
    );
    this.props.onUpdatePhotos(filteredFiles);
  };

  sortImagePosition = images => {
    this.setState({ dataImage: images });
    this.props.onUpdatePhotos(images);
  };
  componentWillReceiveProps(nextProps) {
    if (this.props.dataImage !== nextProps.dataImage) {
      this.setState({
        dataImage: nextProps.dataImage
      });
    }
  }

  render() {
    const { dataImage } = this.state;
    const { accept, maxSize, minSize, multiple } = this.props;
    return (
      <div>
        <Dropzone
          onDrop={this.onDrop}
          style={styles.dropzone}
          accept={accept}
          maxSize={maxSize}
          minSize={minSize}
          multiple={multiple}
        >
          {this.state.isLoading && (
            <div style={styles.insideBox}>
              {" "}
              <CircularProgress />{" "}
            </div>
          )}
          {!this.state.isLoading && (
            <div style={styles.insideBox}>
              <span>Drop your image</span>
              <span>600x600</span>
              <span>or Click here</span>
            </div>
          )}
        </Dropzone>
        <Flex w={[1]} py={[2]}>
          {dataImage &&
            dataImage.length > 0 && (
              <SortableImagePreview
                images={dataImage}
                onRemove={this.onRemove}
                onUpdatePosition={this.sortImagePosition.bind(this)}
              />
            )}
        </Flex>
        <Snackbar
          open={this.state.openSnackBar}
          message={this.state.message}
          autoHideDuration={4000}
          bodyStyle={{ backgroundColor: red500 }}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    );
  }
}

const styles = {
  dropzone: {
    width: 180,
    height: 180,
    marginRight: 8,
    display: "flex",
    borderWidth: 2,
    borderColor: "#D6D6D6",
    borderStyle: "dashed",
    cursor: "pointer",
    borderRadius: 5
  },
  insideBox: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "inherit"
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    padding: 5
  },
  removeButton: {
    position: "absolute",
    top: "0.5rem",
    right: "0.5rem",
    minWidth: "2rem",
    opacity: 1
  },
  image: {
    maxHeight: "14rem",
    margin: "0.2rem",
    maxWidth: "100%"
  }
};

ImageMultiCampaign.propTypes = {
  accept: PropTypes.string,
  maxSize: PropTypes.number,
  minSize: PropTypes.number,
  multiple: PropTypes.bool,
  style: PropTypes.object,
  placeholder: PropTypes.node,
  onUpdatePhotos: PropTypes.func.isRequired,
  dataImage: PropTypes.array,
  nameCampaign: PropTypes.string.isRequired
};

ImageMultiCampaign.defaultProps = {
  multiple: false,
  maxSize: 1000000,
  minSize: 10,
  dataImage: []
};

export default ImageMultiCampaign;



// WEBPACK FOOTER //
// ./src/components/image/ImageMultiCampaign.js